module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/graph-41fcba208e3b30aa85abeb28b53e5ad4.png";